import { space, SpacingKey } from 'theme/themeSpacing'
import { Box } from "@mui/material"

type SpaceProps = {
  x?: SpacingKey
  y?: SpacingKey
}

const Space = ({x, y = 'md'}: SpaceProps) => <Box height={ y && space(y) } width={ x ? space(x) : '100%' }/>

export default Space